import {Component, OnInit, Input} from '@angular/core';
import {Invoice} from "../invoice";
import {LoaderService} from '../../../../services/loader.service';
import {PrintService} from '../../../../services/print.service';

@Component({
  selector: 'app-invoice-print',
  templateUrl: './invoice-print.component.html',
  styleUrls: ['./invoice-print.component.scss']
})
export class InvoicePrintComponent implements OnInit {
  @Input() invoice: Invoice;
  public loading: boolean = false;
  constructor(public loaderService: LoaderService, public printService: PrintService) { }

  ngOnInit() {
  }

  createPdf(action: string, invoiceRefElement: HTMLElement) {
    this.loading = true;
    this.loaderService.show();
    this.printService.renderToPdf(invoiceRefElement).then((doc) => {
      this.printService.finish(action, doc, 'file.pdf');
      this.loading = false;
      this.loaderService.hide();
    }).catch(error => {
      console.error('Error generating PDF:', error);
      this.loading = false;
      this.loaderService.hide();
    });
  }

}
